export interface OperatorLink {
  id: string;
  label: string;
  search: string;
}

const parseLinks = (value: string | null): OperatorLink[] => {
  if (!value) return [];
  try {
    const parsed: unknown = JSON.parse(value);
    return Array.isArray(parsed)
      ? parsed.filter(
          (item): item is OperatorLink =>
            typeof item === "object" &&
            item !== null &&
            typeof item.id === "string" &&
            typeof item.label === "string" &&
            typeof item.search === "string" &&
            item.search.startsWith("?screen="),
        )
      : [];
  } catch {
    return [];
  }
};

const key = (kind: "recent" | "views", adminId: string) => `utopia-backoffice-${kind}-${adminId}`;

export function readRecent(adminId: string) {
  return parseLinks(sessionStorage.getItem(key("recent", adminId)));
}

export function rememberRecent(adminId: string, item: OperatorLink) {
  const next = [item, ...readRecent(adminId).filter((entry) => entry.id !== item.id)].slice(0, 8);
  sessionStorage.setItem(key("recent", adminId), JSON.stringify(next));
  return next;
}

export function readSavedViews(adminId: string) {
  return parseLinks(localStorage.getItem(key("views", adminId)));
}

export function saveView(adminId: string, name: string, search: string) {
  const params = new URLSearchParams(search);
  if (!params.has("screen")) params.set("screen", "dashboard");
  for (const detail of ["detail", "player", "tab"]) params.delete(detail);
  const label = name.trim();
  if (!label) return readSavedViews(adminId);
  const item = { id: label.toLocaleLowerCase(), label, search: `?${params}` };
  const next = [item, ...readSavedViews(adminId).filter((entry) => entry.id !== item.id)].slice(
    0,
    12,
  );
  localStorage.setItem(key("views", adminId), JSON.stringify(next));
  return next;
}

export function removeSavedView(adminId: string, id: string) {
  const next = readSavedViews(adminId).filter((entry) => entry.id !== id);
  localStorage.setItem(key("views", adminId), JSON.stringify(next));
  return next;
}
